export default __webpack_public_path__ + "static/media/topbar-logo.142ee068.svg";